import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AppErrorBoundary } from './components/AppErrorBoundary.js';
import { installChunkRecovery } from './lib/chunkRecovery.js';
import './styles/theme.css';
import './styles/factory.css';
import './styles/cockpit.css';
import './styles/review.css';
import './styles/publish.css';
import './styles/setup.css';
import './styles/recipes.css';
import './styles/wizard.css';
import './styles/konto.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      retry: (count, error) => {
        // 4xx nicht wiederholen, das wird beim zweiten Mal auch nicht besser.
        const status = (error as { status?: number }).status ?? 0;
        if (status >= 400 && status < 500) return false;
        return count < 2;
      },
      refetchOnWindowFocus: true,
    },
  },
});

installChunkRecovery();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppErrorBoundary><App /></AppErrorBoundary>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
